<template>
  <div>
    <quick-check />
    <!-- <financial-standing
      v-if="$route.query.globalReportType.toString() === '2'"
    /> 
    <decision-support v-if="$route.query.globalReportType.toString() === '3'" /> -->
  </div>
</template>

<script>
import QuickCheck from './components/quick-check'
// import FinancialStanding from './components/financial-standing'
// import DecisionSupport from './components/decision-support'

export default {
  components: {
    QuickCheck,
    // FinancialStanding,
    // DecisionSupport,
  },
}
</script>
